<script setup lang="ts">
import { ref } from 'vue';

const virtualScroller = ref<HTMLElement>();
const scrollTop = ref(0);

function scrollDelta(delta: number) {
  if (!virtualScroller.value) return;

  if (parseInt(virtualScroller.value.style.top) !== scrollTop.value) {
    scrollTop.value = parseInt(virtualScroller.value.style.top);
  }
  const newScroll = scrollTop.value + delta;
  /*
  the min max allows for
  - limiting scrolling to ends of the contents when scrolling with mouse wheel
  - allowing automated scrolling (via clicking on annotations, etc) to go past regular scrolling limits, while allowing user to scroll back to a reasonable location without "snapping" to regular min/max
   */
  let modal = document.getElementsByClassName('uk-modal uk-open');
  if (modal.length === 0) {
    const maxPositiveScroll = Math.max(0, scrollTop.value);
    if (newScroll > maxPositiveScroll) {
      scrollTop.value = maxPositiveScroll;
      return;
    }
    const contentHeight =
      (virtualScroller.value.querySelector('*') as HTMLElement)?.offsetHeight || 0;
    const maxNegativeScroll = Math.min(-contentHeight, scrollTop.value);
    if (newScroll < maxNegativeScroll) {
      scrollTop.value = maxNegativeScroll;
      return;
    }
    scrollTop.value = newScroll;
  }
}

function setScroll(height: number) {
  scrollTop.value = height;
}

defineExpose({
  scrollDelta,
  setScroll,
});
</script>

<template>
  <div
    ref="virtualScroller"
    class="virtual-scroll-container"
    :style="{
      top: `${scrollTop}px`,
    }"
  >
    <slot></slot>
  </div>
</template>
